require('./FullName.scss');
// @ vendors
const PropTypes = require('prop-types');
const React = require('react');
const ReactDOM = require('react-dom');
const isEqual = require('lodash/lang/isEqual');

// @helpers
const {formatText, FormattedText} = require('core/i18n').i18n;
const { InputSafe } = require('commonsComponents/inputSafe');

class FullName extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            showFullName: true,
            showNameGroup: false,
            value: this.props.value
        }
        this.handleBlur = this.handleBlur.bind(this);
        this.handleClickFullName = this.handleClickFullName.bind(this);
        this.handleBlurNameGroup = this.handleBlurNameGroup.bind(this);
        this.handleShowNameGroup = this.handleShowNameGroup.bind(this);
        this.handleShowFullName = this.handleShowFullName.bind(this);
        this.handleRegexOnKeyPressAndPaste = this.handleRegexOnKeyPressAndPaste.bind(this);
        this.fullNameInput = React.createRef();
        this.nameInputsWrapper = React.createRef();
    }

    componentWillReceiveProps(nextProps) {
        if (!isEqual(this.props.value, nextProps.value)) {
            this.setState({
                value: nextProps.value
            });
        }
    }

    componentDidUpdate() {
        const errorState = this.props.errorState;
        if ((errorState[0] || errorState[1] || errorState[2]) && this.state.showFullName){
            this.handleShowNameGroup();
        }

        return true;
    }


    removeFocusOnFullName() {
        const element = ReactDOM.findDOMNode(this.fullNameInput.current);

        if (!!element) {
            element.getElementsByTagName('input')[0].blur();
        }
    }

    removeFocusOnNameGroup() {
        const element = ReactDOM.findDOMNode(this.nameInputsWrapper.current);

        if (!!element) {
            const inputs = element.getElementsByTagName('input');
            Array.from(inputs).forEach(inputElement => {
                inputElement.blur();
            });
        }
    }

    handleBlur(event, prop) {
        const inputValue = event.target.value;
        let value = this.state.value;
        value[prop] = inputValue;

       this.props.dataReceiver(value);

       this.setState({
            value
        });

    }

    handleBlurNameGroup(event,prop) {
        const firstName = this.state.value.firstName;
        const lastName = this.state.value.lastName;
        const secondlastName = this.state.value.secondlastName;

        this.handleBlur(event,prop);

        if ((firstName != null && firstName.length > 0) && (lastName != null && lastName.length > 0) && (secondlastName !=null && secondlastName.length > 0) ){
            const { firstName, lastName, secondlastName } = this.state.value;
            const name = firstName + ' ' + lastName + ' ' + secondlastName;
            this.props.updateSimpleIntervener(
                name.toUpperCase(),
                this.state.value.identificationValue
            );
            this.handleShowFullName();
        }
    }

    handleChange(event, prop) {
        const inputValue = event.target.value;
        let value = this.state.value;
        value[prop] = inputValue;

       this.props.dataReceiver(value);

       this.setState({
            value
        });
    }

    handleClickFullName() {
        this.removeFocusOnFullName();
        this.handleShowNameGroup();
    }

    handleRegexOnKeyPressAndPaste(event) {
        const {regex} = this.props;

        const regexText = event.clipboardData
            ? event.clipboardData.getData('text/plain')
            : String.fromCharCode(event.charCode);

        if (regex && !regex.test(regexText) && !event.ctrlKey) {
            event.preventDefault();
        }
    }

    handleShowFullName() {
        this.setState({
            showFullName: true,
            showNameGroup: false
        });

        this.removeFocusOnNameGroup();
    }

    handleShowNameGroup() {
        this.setState({
            showFullName: false,
            showNameGroup: true
        });
    }

    render() {
        const errorState = this.props.errorState;
        const id = this.props.id;
        let idFirstName = id + '_firstname';
        let idSecondlastName = id + '_secondlastname';
        let idLastName = id + '_lastname';
        let idFullName = id + '_fullname';
        let idNameGroup = id + '_nameGroup';
        let showFullName = this.state.showFullName ? '' : "hidden";
        let showNameGroup = this.state.showNameGroup ? '' : "hidden";
        let fullNameValue = this.state.value.firstName + ' ' + this.state.value.lastName + ' ' + this.state.value.secondlastName;
        let fullNameError = (errorState[0] || errorState[1] || errorState[2]);
        const errorMessage = formatText('contractsView-fieldRequired');
        const handleBlur = this.handleBlur;
        const handleBlurNameGroup = this.handleBlurNameGroup;
        return (
            <div className="col-xs-12">
                <div className="ok-slider__text"><FormattedText value={'contractsView-checkingAccountHoldersCompleteName'} /></div>

                <div className={showFullName} onClick={this.handleClickFullName}>
                    <div className="contract-view__input-safe">
                        <InputSafe
                            label={null}
                            placeholder={formatText('contractsView-checkingAccountAddHolderFullName')}
                            name="fullName"
                            ref={this.fullNameInput}
                            referenceName="fullName"
                            type="text"
                            value={fullNameValue}
                            id={idFullName}
                            errorMessage={errorMessage}
                            errorState={fullNameError}
                        />
                    </div>
                </div>
                <div
                    className={showNameGroup}
                    id={idNameGroup}
                    ref={this.nameInputsWrapper}
                >
                    <div className="col-xs-4 first-name-field">
                        <div className="contract-view__input-safe">
                            <InputSafe
                                label={null}
                                placeholder={formatText('contractsView-checkingAccountAddHolderNameTitle')}
                                name="firstName"
                                onBlur={event => handleBlurNameGroup(event, 'firstName')}
                                onChange={event => handleBlur(event, 'firstName')}
                                referenceName="firstName"
                                type="text"
                                onKeyPress={this.handleRegexOnKeyPressAndPaste}
                                onPaste={this.handleRegexOnKeyPressAndPaste}
                                value={this.state.value.firstName}
                                id={idFirstName}
                                maxLength={20}
                                errorMessage={errorMessage}
                                errorState={errorState[0]}
                            />
                        </div>
                    </div>
                    <div className="col-xs-4 last-name-field">
                        <div className="contract-view__input-safe">
                            <InputSafe
                                label={null}
                                placeholder={formatText('contractsView-checkingAccountAddHolderLastName')}
                                name="lastName"
                                onBlur={event => handleBlurNameGroup(event, 'lastName')}
                                onChange={event => handleBlur(event, 'lastName')}
                                referenceName="lastName"
                                type="text"
                                onKeyPress={this.handleRegexOnKeyPressAndPaste}
                                onPaste={this.handleRegexOnKeyPressAndPaste}
                                value={this.state.value.lastName}
                                id={idLastName}
                                maxLength={30}
                                errorMessage={errorMessage}
                                errorState={errorState[1]}
                            />
                        </div>
                    </div>
                    <div className="col-xs-4 last-name-field">
                        <div className="contract-view__input-safe">
                            <InputSafe
                                label={null}
                                placeholder={formatText('contractsView-checkingAccountAddHolderSecondLastName')}
                                name="secondlastName"
                                onBlur={event => handleBlurNameGroup(event, 'secondlastName')}
                                onChange={event => handleBlur(event, 'secondlastName')}
                                referenceName="secondlastName"
                                type="text"
                                onKeyPress={this.handleRegexOnKeyPressAndPaste}
                                onPaste={this.handleRegexOnKeyPressAndPaste}
                                value={this.state.value.secondlastName}
                                id={idSecondlastName}
                                maxLength={30}
                                errorMessage={errorMessage}
                                errorState={errorState[2]}
                            />
                        </div>
                    </div>
                </div>

            </div>
        );
    }

}

FullName.propTypes = {
    dataReceiver: PropTypes.func,
    value: PropTypes.any.isRequired,
    id: PropTypes.any.isRequired,
    errorState: PropTypes.any.isRequired,
    errorMessage: PropTypes.any.isRequired,
    regex: PropTypes.any,
    updateSimpleIntervener: PropTypes.func
};

FullName.defaultProps = {
    value: {firstName: '', lastName: '', secondlastName: ''},
    id: 'full_name',
    errorState: false,
    errorMessage: ''
};

module.exports = FullName;
